const countFormatter = (count = 0) => {
    if (count < 1) return;

    if (count > 999) {
        return `${(count / 1000).toFixed(1)}k`;
    }

    return `${count}`;
};

export { countFormatter };
